import { inject, Injectable } from '@angular/core'
import { Router, type UrlTree } from '@angular/router'
import { map, type Observable } from 'rxjs'
import { PermissionsService } from './permissions.service'

@Injectable({
  providedIn: 'root',
})
export class ContactsGuard {
  readonly #permissionsService = inject(PermissionsService)
  readonly #router = inject(Router)

  canActivate(): Observable<boolean | UrlTree> {
    return this.#permissionsService.hasContactsAccess$.pipe(
      map(hasAccess => (hasAccess ? true : this.#router.parseUrl('/')))
    )
  }
}
